import { useWindowSize } from "@app/Helpers";
import Button from "@components/Button";
import LinearProgressBar from "@components/LinearGradientProgressBar";
import PagesHeader from "@components/PagesHeader";
import StickyButton from "@components/StickyButton";
import circleCheckSrc from "../img/circle-check.svg";
import "./style.scss";

export default function QrCodeConfirm({ onNext }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  return (
    <section className="qr-code-confirm">
      <div>
        <PagesHeader>
          <p><strong>Vuse</strong> Umfrage</p>
        </PagesHeader>
        <div className="qr-code-confirm__progress">
          <LinearProgressBar value={0.1} startStepColor="#47B5BF" endStepColor="#008888" />
        </div>
      </div>
      <div className="qr-code-confirm__body">
        <div className="qr-code-confirm__content">
          <div className="qr-code-confirm__icon-box">
            <img src={circleCheckSrc} alt="" width="70" height="70" aria-hidden="true" />
          </div>
          <h2 className="qr-code-confirm__title">
            <strong>Code</strong> erfolgreich verifiziert
          </h2>
          {XGA && (
            <div className="qr-code-confirm__cta">
              <Button action={onNext} btnClass="ultra-insider">Weiter</Button>
            </div>
          )}
        </div>
      </div>
      {!XGA && (
        <StickyButton action={onNext}>
          Weiter
        </StickyButton>
      )}
    </section>
  );
}
